import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { MuiSwitch } from '../MaterialUIComponents'
import theme from '../../../assests/theme'

const useStyles = makeStyles({
    root: {
        width: "44px",
        height: "20px",
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        border: "1px solid "+theme.palette.primary.light,
        '&$checked': {
            transform: 'translateX(24px)',
            color: "white",
            '& + $track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.primary.main,
        },
    },
    thumb: {
        width: "16px",
        height: "16px",
    },
    track: {
        borderRadius: (20 / 2) + "px",
        backgroundColor: theme.palette.primary.lightest,
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
})

export default function Switch(props) {
    const classes = useStyles();

    return (
        <MuiSwitch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
};